export enum SensorLockerStatus {
    OPENING = 'opening',
    UNLOCKED = 'unlocked',
    OPENED = 'opened',
    NOT_OPENED = 'not_opened',
    CLOSED = 'closed',
    NOT_CLOSED = 'not_closed',
    ERROR = 'error'
}